// Counts down to `target` (ISO 8601). Time is measured against the server's
// clock rather than the visitor's, so a wrong device clock can't open or close
// the form early.
//
// state: 'upcoming' (counting to the start) or 'open' (counting to the end)
export const countdown = (target, serverNow, state) => ({
	state: state,
	days: '00',
	hours: '00',
	minutes: '00',
	seconds: '00',
	timer: null,
	targetTime: Date.parse(target),
	clockOffset: Date.parse(serverNow) - Date.now(),
	pad(value) {
		return String(value).padStart(2, '0')
	},
	tick() {
		const remaining = Math.max(0, this.targetTime - (Date.now() + this.clockOffset))
		const totalSeconds = Math.floor(remaining / 1000)

		this.days = this.pad(Math.floor(totalSeconds / 86400))
		this.hours = this.pad(Math.floor((totalSeconds % 86400) / 3600))
		this.minutes = this.pad(Math.floor((totalSeconds % 3600) / 60))
		this.seconds = this.pad(totalSeconds % 60)

		if (remaining === 0) {
			clearInterval(this.timer)

			if (this.state === 'upcoming') {
				// The form isn't rendered until entries open, so fetch the open page
				window.location.reload()
			} else {
				this.state = 'closed'
			}
		}
	},
	init() {
		this.tick()
		this.timer = setInterval(() => this.tick(), 1000)
	},
	destroy() {
		clearInterval(this.timer)
	},
})
